<template lang="pug">
  button.button.button--icon(
    type="button",
    :disabled="isDisabled",
    @click="$emit('click')"
  )
    icon(v-if="icon", :name="icon", :size="size")
    span.u-sr-only {{ label }}
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';

  export default {
    name: 'BaseButton',
    components: { Icon },
    extends: BaseButton,
    props: {
      size: String,
    },
  };
</script>

<style scoped lang="scss"></style>
